<template>
  <div class="manage-orders" style="padding: 10px">
    <div class="equipements" v-if="$store.getters[dataKey].length == 0 && emptyData.show">
      <div>
        <div class="equipements-empty">
          <img :src="emptyData.imgSrc" />
          <div class="title">{{ emptyData.message }}</div>
          <t-button
            v-if="showButton"
            :buttonClass="'centered-button'"
            :label="emptyData.label"
            :icon="emptyData.icon"
            :iconPosition="'left'"
            :onClick="emptyData.function"
          />
        </div>
      </div>
    </div>

    <div
      style="width: 100%"
      class="dt-datatable"
      v-if="$store.getters[dataKey].length > 0"
    >
      <DataTable
        :value="tableData"
        v-model:selection="selectedData.value"
        dataKey="id"
        :paginator="true"
        :lazy = "lazy"
        :totalRecords="totalRecords"
        :rows="rows"
        v-model:filters="filters1"
        filterDisplay="menu"
        style="margin-top: auto; width: 100%; overflow-x: scroll"
        :globalFilterFields="getGlobalFiltersFields"
        responsiveLayout="stack"
        breakpoint="768px"
        @rowExpand="onRowExpand"
        :resizableColumns="true"
        columnResizeMode="fit"
        :scrollable="scrollable"
        v-model:expandedRows="expandedRows"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="rowsPerPageOptions"
        currentPageReportTemplate=""
        removableSort
        @page = "atPage($event)"
      >
        <template #header>
          <div class="p-d-flex p-jc-between">
            <div v-if="$store.getters[dataKey].length > 0">
              <div>
                <t-button
                  v-if="config.editable"
                  :disabled="
                    selectedData.value.length == 0 || selectedData.value.length > 1
                  "
                  :buttonClass="'button-margin'"
                  :label="'Edit'"
                  :icon="'pi pi-pencil'"
                  :iconPosition="'left'"
                  :color="'light'"
                  :onClick="() => config.editSettings.function(selectedData.value[0].id)"
                />
                <t-button
                  v-if="config.addNew"
                  :buttonClass="'button-margin'"
                  :label="config.addNewSettings.label"
                  :icon="config.addNewSettings.icon"
                  :iconPosition="'left'"
                  style="margin: 0 10px"
                  :color="'light'"
                  :onClick="() => config.addNewSettings.function()"
                />
                <template v-for="(action, y) in customActions" :key="'action' + y">
                  <t-button
                    :disabled="
                      selectedData.value.length == 0 || selectedData.value.length > 1
                    "
                    :buttonClass="'button-margin'"
                    :label="action.label"
                    :icon="action.icon"
                    :iconPosition="'left'"
                    :color="'light'"
                    :onClick="() => applyCustomAction(action, selectedData.value[0].id)"
                  />
                </template>
              </div>
            </div>
            <span v-if="!hideSearch" class="p-input-icon-right" style="border-radius:4px; ">
              <i class="pi pi-search" style="color: #808285" />
              <InputText
                v-model="filters1['global'].value"
                placeholder="Keyword Search"
                class="p-column-filter"
              />
            </span>
          </div>
        </template>
        <template v-if="showCheckboxes">
          <Column  selectionMode="multiple" headerStyle="width: 2rem" ></Column>
          <Column  :expander="config.expand" headerStyle="width: 1rem"  />
        </template>
        <template v-else>
          
        </template>
        <Column
          v-for="(column, i) in config.columns"
          :key="i"
          :header="column.title"
          :field="getNestedKey(column)"
          :style="column.style"
        >
          <template #body="slotProps">
            <div
              v-if="column.click"
              @click.prevent="column.click(slotProps.data)"
              v-html="getNestedValue(slotProps.data, column)"
              class="p-column-info"
            ></div>
            <div
              v-else
              v-html="getNestedValue(slotProps.data, column)"
              class="p-column-info"
            ></div>
          </template>
        </Column>
        <template #empty>
          <div
            class="empty-state"
            style="width: max-content"
            v-if="$store.getters[dataKey].length === 0"
          >
            <div class="title">{{ config.emptyText }}</div>
          </div>
        </template>
        <template #expansion="slotProps">
          <div class="orders-subtable">
            <h5>{{ config.expandSettings.title }}</h5>
            <DataTable
              :value="slotProps.data[config.expandSettings.key]"
              responsiveLayout="scroll"
              :resizableColumns="true"
              columnResizeMode="fit"
            >
              <Column
                v-for="(column1, j) in config.expandSettings.columns"
                :key="'details-' + j"
                :header="column1.title"
                :disabled="false"
              >
                <template #body="slotProps">
                  <div
                    v-if="column1.click"
                    @click="column1.click(slotProps.data)"
                    v-html="getNestedValue(slotProps.data, column1)"
                  ></div>
                  <div v-else v-html="getNestedValue(slotProps.data, column1)"></div>
                </template>
              </Column>
            </DataTable>
          </div>
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import TButton from "../../../common/components/buttons/TButton.vue";
import Column from "primevue/column";
import {reactive} from "@vue/reactivity";
import store from "../../../store";
import GeneralHelper from "../../helpers/GeneralHelper";
import {FilterMatchMode} from "primevue/api";
import InputText from "primevue/inputtext";

import {defineAsyncComponent} from "vue";
import translation from "../../../translations";
const DataTable = defineAsyncComponent(() =>
  import("primevue/datatable/datatable.esm.min.js")
);

export default {
  components: {DataTable, Column, TButton, InputText},
  data() {
    return {
      orders: this.$store.getters.orders,
      selectedOrders: [],
      equipements: [],
      expandedRows: [],
      filters1: {},
      getGlobalFiltersFields: [],
    };
  },
  created() {
    this.initFilters1();
  },
  watch: {
    selectedData: {
      handler: function (newValue) {
        this.$emit("selectedChanged", newValue);
        console.log(this.selectedData)
      },
      deep: true,
    },
  },
  setup(props) {
    let selectedData = reactive({
      value: [],
    });
    const getData = () => {
      store.dispatch(props.actions.get);
    };

    const applyCustomAction = async (action, data) => {
      var r = await action.function(data);
      selectedData.value = [];
    };
    const onRowExpand = (event) => {
      props.config.expandSettings.onRowExpand(event.data.id);
    };
    const unselectSelectedData = () => {
      selectedData.value = [];
    };
    if (props.actions.get)
      getData();

    return {
      getData,
      selectedData,
      onRowExpand,
      applyCustomAction,
      unselectSelectedData,
    };
  },
  methods: {
    initFilters1() {
      this.filters1 = {};
      this.filters1["global"] = {
        value: null,
        matchMode: FilterMatchMode.CONTAINS,
      };
      var that = this;
      this.config.columns.forEach(function (item) {
        var key = that.getNestedKey(item);
        if (key) {
          that.getGlobalFiltersFields.push(key);
          that.filters1[key] = {
            value: null,
            matchMode: FilterMatchMode.CONTAINS,
          };
        }
      });

    },
    rowClass(data) {
      if (data.status === "Live")
        return data.confirmed ? "row-confirmed" : "row-unconfirmed";
      else return "row-normal";
    },
    getNestedKey(column) {
      if (column.keys == undefined) return;
      var keys = "";
      for (var j = 0; j < column.keys.length; j++) {
        if (j == 0) keys = column.keys[j];
        else keys += "." + column.keys[j];
      }

      return keys;
    },
    getNestedValue(row, column) {
      if (column.custom != undefined) {
        return column.custom(row);
      } else {
        var s = row;
        column.keys.forEach(function (item) {
          if (s[item] != undefined) s = s[item];
          else {
            s = "";
            return;
          }
        });

        if (column.style == "dash") {
          var data = s;
          if (!Array.isArray(s)) data = s.split(",");
          s = "";
          data.forEach((item, key) => {
            s += item;
            if (key < data.length - 1) s += " / ";
          });
        } else if (column.style == "id") {
          s = "#" + GeneralHelper.pad(s, 5);
          return "<td style='width:50px !important'>" + translation(s) + "</td>";
        } else if (column.style == "boolean") {
          return s == (column.mode == "oposite" ? false : true)
            ? "<i v-html='rawHtml' class='pi pi-check' style='color:green'/>"
            : "<i v-html='rawHtml' class='pi pi-times' style='color:red'/>";
        } else if (column.style == "image") {
          return "<img style='min-width:50px !important; width:50px !important; ' src='" + s + "'/>";
        }

        if (s.length == 0) s = "-";
        return s;
      }
    },
  },

  props: {
    emptyData: {
      default: {show: false},
    },
    config: {
      required: true,
    },
    actions: {
      required: true,
    },
    dataKey: {
      required: true,
    },
    lazy: {
      default:false
    },
    totalRecords:{
      type: Number,
      default:1000000000000000
    },
    atPage: {
      type: Function,
      default: ()=>{}
    },

    rowsPerPageOptions: {
      type: Array,
      default: ()=>[10,20,50]
    },

    rows:{
      type: Number,
      default:10
    },

    hideSearch:{
      type:Boolean,
      default:false
    },

    showCheckboxes:{
      type:Boolean,
      default: true
    },
    scrollable:{
      type:Boolean,
      default: false
    },
    customActions: Array,
  },
  computed: {
    tableData() {
      return this.$store.getters[this.dataKey];
    },
  },
};
</script>

<style lang="scss">
.empty-state {
  margin-left: auto;
  margin-left: auto;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  vertical-align: middle;

  img {
    width: 150px;
    height: 150px;
    margin: auto;
  }
  .title {
    display: flex;
    align-items: center;
    @include f-empty-state-large;
    color: $grey;
  }

  @media screen and (max-width: 768px) {
    .title {
      @include f-empty-state;
    }
  }
}

@media screen and(max-width:1400px) {
  .manage-orders {
    width: 100% !important;
    padding: 0 25px !important;
  }
}

@media screen and(max-width:1050px) {
  .manage-orders {
    width: 100% !important;
    padding: 0 25px !important;
  }

  
}

.p-column-info {
  //width: auto;
  @include f-label;
  font-weight: 500;
  @media screen and (max-width: 768px) {
    width: 50% !important;
    text-align: right;
  }
}

.manage-orders {
  width: 100%;
  max-width: 1920px;
  .orders-subtable {
    background: $background-color;
    padding: 5px;
    width: 100%;
    padding-left: 20px;
  }

  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 100px;

  .equipements {
    margin-left: auto;
    margin-right: auto;

    .equipements-empty {
      display: flex;
      flex-direction: column;
      img {
        width: 150px;
        height: 150px;
        margin: auto;
      }
      .title {
        display: flex;
        align-items: center;
        @include f-empty-state-large;
        color: $grey;
      }
      @media screen and (max-width: 768px) {
        .title {
          @include f-empty-state;
          text-align: center;
        }
      }
      .centered-button {
        margin-left: auto;
        margin-right: auto;
        margin-top: 25px;
      }
      .centered-image {
        width: 250px !important;
        height: 250px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .buttons-table {
      width: 99% !important;
    }
  }
  .buttons-table {
    margin-top: 25px;
    display: flex;
    margin-right: auto;
    flex-direction: column;
    .buttons {
      flex-direction: row;
      margin-bottom: 20px;
      .button-margin {
        margin-right: 20px;
      }
    }
    @media screen and (max-width: 1050px) {
      .buttons {
        flex-direction: column;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        .button-margin {
          margin-bottom: 20px;
          margin-right: 0px;
        }
      }
    }
    .status {
      @include f-body3;
      color: black;
      width: 100%;
    }
    .order-title {
      display: flex;
      align-items: center;
      .title {
        @include f-button;
        color: black;
        padding-left: 7px;
        padding-right: 5px;
      }
      .category {
        @include f-body3;
        color: black;
      }
      .order-cell-style {
        @include f-body3;
        text-align: right;
        color: black;
      }
    }
    .hidden {
      visibility: hidden;
    }
    .product {
      display: flex;
      .brand {
        @include f-button;
        color: black;
        margin-right: 7px;
      }
      .productName {
        @include f-button;
        display: flex;
        align-items: center;
        color: black;
        margin-right: 5px;
     
      }
      .category {
        @include f-body2;
        color: black;
        margin-right: 5px;
      }
      .modelNumber {
        color: black;
        @include f-body2;
      }
    }
    .inputSelect {
      height: 42px;
      max-width: 107px !important;
      min-width: 107px !important;
      .p-dropdown-trigger {
        border: none !important;
        padding-right: 10px;
      }
      .p-inputtext {
        border-radius: 15px;
        display: flex;
        align-items: center;
      }
    }
  }
}

.dt-datatable {
  max-width: 1920px;

  .p-column-filter {
    border-radius: 4px !important;
    background-color: $background-color2 !important;
    height: 38px;
    width: 296px;
    border-color: $background-color2 !important;
    color: $brand-color;
    @media screen and (max-width: 500px) {
      width: 200px;
    }
    @media screen and (max-width: 380px) {
      width: 175px;
    }
    @include f-label;
    font-weight: 500;
  }

  .p-datatable .p-datatable-tbody .p-datatable-emptymessage > td {
    border: none;
  }
  .p-datatable .p-datatable-thead {
    border: 0px !important;
    border-color: $background-color !important;
  }
  .p-datatable .p-datatable-thead > tr > th {
    color: $dark-grey !important;
    background: $background-color !important;
    @include f-table-header;
    padding: .5rem !important;
  }

  .p-datatable .p-datatable-tbody > tr {
    height: 46px;
  }
  .row-normal {
    border-width: 0 0 0 4px;
    border-color: $border-color;
  }
  ::-webkit-scrollbar {
    height: 5px;
    width: 5px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $grey;
    border-radius: 10px;
  }
  .row-confirmed {
    border-width: 0 0 0 4px;
    border-color: rgb(82, 196, 26);
  }
  .row-unconfirmed {
    border-width: 0 0 0 4px;
    border-color: rgb(251, 78, 78);
    background: rgba(251, 78, 78, 0.1);
  }
  .p-checkbox {
    width: 18px !important;
    height: 18px !important;
    .p-checkbox-box {
      min-width: 18px !important;
      width: 18px !important;
      height: 18px !important;
    }
  }
  .p-checkbox .p-checkbox-box.p-highlight .p-checkbox-icon.pi-check:before {
    top: 9px !important;
    left: 3px !important;
  }

  .p-sortable-column .p-column-header-content {
    justify-content: space-between;
    width: 100%;
  }
  .p-field {
    margin-bottom: 0 !important;
  }

  .at-r {
    text-align: right;
    width: 124px !important;
    max-height: 42px;
  }
  .at-width {
    max-height: 42px;
  }
  .EmptyTable {
    @include f-banner;
    color: $dark-grey2;
  }
  .p-paginator {
    width: 100%;
  }

  .p-datatable .p-paginator-bottom {
    border-width: 0 !important;
  }

  td {
    @include f-table-info;
    color: black;
    word-wrap: break-word;
  }
}

.p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
  background-color: $tertiary-color !important;
  border-color: $tertiary-color !important;
  color: white !important;
  @include f-button;
  height: 40px !important;
  width: 40px !important;
}

.p-paginator .p-paginator-pages .p-paginator-page {
  border: 1px solid $border-color !important;
  color: black;
  @include f-button;
  height: 40px !important;
  width: 40px !important;
  min-width: unset !important;
}

.p-input-filled .p-dropdown {
  border-radius: 4px !important;
  background: $background-color !important;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  color: $brand-color;
  background: $background-color !important;
  @include f-button;
}

.p-datatable .p-datatable-tbody > tr.p-highlight {
  background: $background-color2;
}

.p-datatable-resizable .p-datatable-tbody > tr > td {
  white-space: pre-wrap !important;
  padding: .5rem !important;
}


@media screen and (max-width: 768px) {
 

  

  .p-datatable .p-datatable-tbody > tr > td > .p-column-title {
    color: $dark-grey !important;
    @include f-table-header;
  }

  .p-datatable .p-datatable-tbody > tr > td  {
    border-width: 0;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 1px;
    padding-bottom: 1px;
  }


  .p-datatable .p-datatable-tbody > tr:nth-child(even) {
    border: 1px solid $background-color2;
    flex: 0 0 calc(50% - 16px);
    margin: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding-bottom: 15px;
    
  }

  .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
 
    border: 1px solid $background-color2;
    flex: 0 0 calc(50% - 16px);
    margin: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding-bottom: 15px;
   
  }

  .p-datatable .p-datatable-tbody {
    display: flex;
    flex-direction: column;
    width: 350px;
    margin: auto;
    @media screen and (max-width: 510px ) {
      width: 95%;
    }
  }

  @media screen and (max-width: 480px) {
    .p-column-info {
      width: unset !important;
    }
  }


}
</style>
